import { User, Workspace } from "shared";

const LIVE_CHAT_BUTTON_TAG = "bs-live-chat-button";

/**
 * Loads the live chat button async.
 * @param open
 * @param userData
 */
export async function loadLiveChatButton({
	open,
	removeWhenClosed
}: { open?: boolean; user?: User | null; workspace?: Workspace | null; removeWhenClosed?: boolean } = {}) {
	let $button = document.querySelector(LIVE_CHAT_BUTTON_TAG);
	if ($button == null) {
		import("./../molecules/live-chat-button");
		$button = document.createElement(LIVE_CHAT_BUTTON_TAG);
		document.body.appendChild($button);
	}

	$button.toggleAttribute("remove-when-closed", removeWhenClosed ?? false);
	$button.toggleAttribute("auto-open", open ?? false);
}

export function hideLiveChatButton() {
	const $button = document.querySelector(LIVE_CHAT_BUTTON_TAG);
	if ($button != null) $button.remove();
}
